class EventBus {
  callbacks: Record<string, Function[]>;

  constructor() {
    this.callbacks = {};
  }

  on(eventName: string, fn: Function) {
    if (!this.callbacks[eventName]) {
      this.callbacks[eventName] = [];
    }
    this.callbacks[eventName].push(fn);
  }

  trigger(eventName: string, ...args: any[]) {
    if (this.callbacks[eventName]) {
      this.callbacks[eventName].forEach((fn: Function) => {
        fn(args);
      });
    }
  }

  remove(eventName: string) {
    delete this.callbacks[eventName];
  }
}

export default new EventBus();
